goog.provide("shadow.js.shim.module$dayjs$locale$ko");
goog.provide("module$shadow_js_shim_module$dayjs$locale$ko");
shadow.js.shim.module$dayjs$locale$ko = shadow.js.nativeProvides["dayjs/locale/ko"] = require("dayjs/locale/ko");
module$shadow_js_shim_module$dayjs$locale$ko.default = shadow.js.shim.module$dayjs$locale$ko;
